'use strict';

module.exports = {
  __init__: [ 'lassoTool' ],
  lassoTool: [ 'type', require(113) ]
};
